import { Validator } from '@vista-digital/validator';
import { FieldFormatType } from '../../../../../types/form/field-format-type';
import { textFieldValidationConfigValidatorSchema } from '../../../../../types/form/field-validation-config';
export const defaultCurrentPasswordFieldValidationConfig = {
    type: FieldFormatType.Text,
    required: true,
    maxLength: 64
};
export const currentPasswordFieldValidationConfigValidator = Validator.object(Object.assign(Object.assign({}, textFieldValidationConfigValidatorSchema), { required: Validator.isEqualTo(true) }));
//# sourceMappingURL=validation-config.js.map